import _objectWithoutProperties from "/home/runner/work/discretize.eu/discretize.eu/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/discretize.eu/discretize.eu/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/runner/work/discretize.eu/discretize.eu/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/discretize.eu/discretize.eu/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["className", "size"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import e, { Fragment as s, useState as r, useEffect as i } from "react";
import t from "classnames";
import { Tooltip as a, Item as n, CreateItem as o, CommonEffect as l, Trait as x, Skill as d, Condition as p, Boon as c, Attribute as m, Profession as u, DetailsHeader as f, Icon as j, ConsumableEffect as g } from "@discretize/gw2-ui-new";
var h = {
    exports: {}
  },
  I = {},
  _ = e,
  N = Symbol.for("react.element"),
  y = Symbol.for("react.fragment"),
  w = Object.prototype.hasOwnProperty,
  v = _.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
  b = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };
function A(e, s, r) {
  var i,
    t = {},
    a = null,
    n = null;
  for (i in void 0 !== r && (a = "" + r), void 0 !== s.key && (a = "" + s.key), void 0 !== s.ref && (n = s.ref), s) {
    w.call(s, i) && !b.hasOwnProperty(i) && (t[i] = s[i]);
  }
  if (e && e.defaultProps) for (i in s = e.defaultProps) {
    void 0 === t[i] && (t[i] = s[i]);
  }
  return {
    $$typeof: N,
    type: e,
    key: a,
    ref: n,
    props: t,
    _owner: v.current
  };
}
I.Fragment = y, I.jsx = A, I.jsxs = A, h.exports = I;
var R = "HelperIcon-module_svg__eIXEH";
var S = function S(_ref) {
  var e = _ref.text,
    s = _ref.fontSize;
  return h.exports.jsx(a, {
    content: e,
    children: h.exports.jsx("span", {
      children: h.exports.jsx("svg", {
        style: {
          fontSize: s || "1.4rem"
        },
        className: R,
        viewBox: "0 0 24 24",
        children: h.exports.jsx("path", {
          fill: "currentColor",
          d: "M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"
        })
      })
    })
  });
};
var T = "Switch-module_toggle__il2Kr",
  C = "Switch-module_toggle__input__C4cXl",
  k = "Switch-module_toggle__fill__HfFgs",
  M = "Switch-module_wrapper__inoDp";
var O = function O(_ref2) {
  var e = _ref2.onChange,
    s = _ref2.label;
  return h.exports.jsxs("span", {
    className: M,
    children: [h.exports.jsxs("label", {
      className: T,
      htmlFor: "myToggle",
      children: [h.exports.jsx("input", {
        className: C,
        name: "",
        type: "checkbox",
        id: "myToggle",
        onChange: e
      }), h.exports.jsx("div", {
        className: k
      })]
    }), s]
  });
};
var E = {
  gw2Item: "defaultStyles-module_gw2Item__mztg0",
  title: "defaultStyles-module_title__WWoe9",
  infusions: "defaultStyles-module_infusions__a5HQD"
};
var F = function F(_ref3) {
  var e = _ref3.id,
    s = _ref3.affix,
    r = _ref3.upgrades,
    i = _ref3.type,
    t = _ref3.weight,
    a = _ref3.rarity;
  var l = {
    disableText: !0,
    className: E.gw2Item,
    upgrades: r ? (x = r, x && x.filter(function (e) {
      return "number" == typeof e || Array.isArray(e);
    })) : [],
    stat: s || ""
  };
  var x;
  return h.exports.jsx(h.exports.Fragment, {
    children: e ? h.exports.jsx(n, _objectSpread({
      id: e
    }, l)) : h.exports.jsx(o, _objectSpread({
      type: i || "",
      weight: t,
      rarity: a
    }, l))
  });
};
function L(e) {
  if (null == e || "" === e) return "";
  return e.split(" ").map(function (e) {
    return e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
  }).join(" ").trim();
}
var z = "Armor-module_list__FYbdR",
  B = "Armor-module_listItem__IlBJI",
  H = "Armor-module_listItemText__sdXlE",
  D = "Armor-module_primaryText__gd-eP",
  $ = "Armor-module_secondaryText__7I5Pd";
function P(e, s) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var i = [];
  return e && (i = [e]), s && (i = [].concat(_toConsumableArray(i), [[s, r]])), i;
}
function U(e) {
  return L(e.replace(/Superior Rune of (the)?/gm, "").replace("Runa superior del ", "").replace(/Überlegene Rune (des|der|von)?/gm, "").replace("Rune d'érudit ", ""));
}
function V(e) {
  var s = e.match(/.*\+[0-9][0-9]?/g);
  return 1 === (s === null || s === void 0 ? void 0 : s.length) ? s[0] : e;
}
var W = function W(_ref4) {
  var e = _ref4.weight,
    s = _ref4.showInfusions,
    r = _ref4.helmId,
    i = _ref4.helmRuneId,
    t = _ref4.helmInfusionId,
    _ref4$helmRuneCount = _ref4.helmRuneCount,
    a = _ref4$helmRuneCount === void 0 ? 6 : _ref4$helmRuneCount,
    o = _ref4.helmAffix,
    l = _ref4.helmRune,
    x = _ref4.helmRarity,
    d = _ref4.shouldersId,
    p = _ref4.shouldersRuneId,
    c = _ref4.shouldersInfusionId,
    _ref4$shouldersRuneCo = _ref4.shouldersRuneCount,
    m = _ref4$shouldersRuneCo === void 0 ? 6 : _ref4$shouldersRuneCo,
    u = _ref4.shouldersAffix,
    f = _ref4.shouldersRune,
    j = _ref4.shouldersRarity,
    g = _ref4.coatId,
    I = _ref4.coatRuneId,
    _ = _ref4.coatInfusionId,
    _ref4$coatRuneCount = _ref4.coatRuneCount,
    N = _ref4$coatRuneCount === void 0 ? 6 : _ref4$coatRuneCount,
    y = _ref4.coatAffix,
    w = _ref4.coatRune,
    v = _ref4.coatRarity,
    b = _ref4.glovesId,
    A = _ref4.glovesRuneId,
    R = _ref4.glovesInfusionId,
    _ref4$glovesRuneCount = _ref4.glovesRuneCount,
    S = _ref4$glovesRuneCount === void 0 ? 6 : _ref4$glovesRuneCount,
    T = _ref4.glovesAffix,
    C = _ref4.glovesRune,
    k = _ref4.glovesRarity,
    M = _ref4.leggingsId,
    O = _ref4.leggingsRuneId,
    E = _ref4.leggingsInfusionId,
    _ref4$leggingsRuneCou = _ref4.leggingsRuneCount,
    L = _ref4$leggingsRuneCou === void 0 ? 6 : _ref4$leggingsRuneCou,
    W = _ref4.leggingsAffix,
    Q = _ref4.leggingsRune,
    X = _ref4.leggingsRarity,
    Y = _ref4.bootsId,
    q = _ref4.bootsRuneId,
    J = _ref4.bootsInfusionId,
    _ref4$bootsRuneCount = _ref4.bootsRuneCount,
    G = _ref4$bootsRuneCount === void 0 ? 6 : _ref4$bootsRuneCount,
    K = _ref4.bootsAffix,
    Z = _ref4.bootsRune,
    ee = _ref4.bootsRarity;
  var se = function se(_ref5) {
    var e = _ref5.affix,
      r = _ref5.infusionId,
      i = _ref5.runeId,
      t = _ref5.runeName;
    return h.exports.jsxs("div", {
      className: H,
      children: [h.exports.jsx("span", {
        className: D,
        children: e
      }), h.exports.jsxs("div", {
        className: $,
        children: [i ? h.exports.jsx(n, {
          id: i,
          text: U
        }) : t, s && h.exports.jsxs(h.exports.Fragment, {
          children: [h.exports.jsx("br", {}), r && h.exports.jsx(n, {
            id: r,
            text: V
          })]
        })]
      })]
    });
  };
  return h.exports.jsxs("ul", {
    className: z,
    children: [h.exports.jsxs("li", {
      className: B,
      children: [h.exports.jsx(F, {
        id: r,
        type: "Helm",
        weight: e,
        rarity: x,
        affix: o,
        upgrades: P(t, i, a)
      }), h.exports.jsx(se, {
        affix: o,
        runeId: i,
        infusionId: t,
        runeName: l
      })]
    }), h.exports.jsxs("li", {
      className: B,
      children: [h.exports.jsx(F, {
        id: d,
        type: "Shoulders",
        weight: e,
        rarity: j,
        affix: u,
        upgrades: P(c, p, m)
      }), h.exports.jsx(se, {
        affix: u,
        runeId: p,
        infusionId: c,
        runeName: f
      })]
    }), h.exports.jsxs("li", {
      className: B,
      children: [h.exports.jsx(F, {
        id: g,
        type: "Coat",
        weight: e,
        rarity: v,
        affix: y,
        upgrades: P(_, I, N)
      }), h.exports.jsx(se, {
        affix: y,
        runeId: I,
        infusionId: _,
        runeName: w
      })]
    }), h.exports.jsxs("li", {
      className: B,
      children: [h.exports.jsx(F, {
        id: b,
        type: "Gloves",
        weight: e,
        rarity: k,
        affix: T,
        upgrades: P(R, A, S)
      }), h.exports.jsx(se, {
        affix: T,
        runeId: A,
        infusionId: R,
        runeName: C
      })]
    }), h.exports.jsxs("li", {
      className: B,
      children: [h.exports.jsx(F, {
        id: M,
        type: "Leggings",
        weight: e,
        rarity: X,
        affix: W,
        upgrades: P(E, O, L)
      }), h.exports.jsx(se, {
        affix: W,
        runeId: O,
        infusionId: E,
        runeName: Q
      })]
    }), h.exports.jsxs("li", {
      className: B,
      children: [h.exports.jsx(F, {
        id: Y,
        type: "Boots",
        weight: e,
        rarity: ee,
        affix: K,
        upgrades: P(J, q, G)
      }), h.exports.jsx(se, {
        affix: K,
        runeId: q,
        infusionId: J,
        runeName: Z
      })]
    })]
  });
};
var Q = "AssumedBuffs-module_component__cNlYQ";
var X = function X(_ref6) {
  var e = _ref6.value,
    s = _ref6.className;
  return h.exports.jsx("div", {
    className: s,
    children: e.map(function (_ref7, i) {
      var e = _ref7.id,
        s = _ref7.type,
        r = _ref7.gw2id;
      var a = "".concat(s, "_").concat(e, "-").concat(r, "-").concat(i);
      switch (s) {
        case "Boon":
          return h.exports.jsx(c, {
            name: L(e),
            disableText: !0,
            className: t(Q)
          }, a);
        case "Condition":
          return h.exports.jsx(p, {
            name: L(e),
            disableText: !0,
            className: Q
          }, a);
        case "Skill":
          return h.exports.jsx(d, {
            id: r,
            disableText: !0,
            className: Q
          }, a);
        case "Trait":
          return h.exports.jsx(x, {
            id: r,
            disableText: !0,
            className: Q
          }, a);
        case "CommonEffect":
          return h.exports.jsx(l, {
            name: L(e),
            disableText: !0,
            className: Q
          }, a);
        case "Item":
          return h.exports.jsx(n, {
            id: r,
            disableText: !0,
            className: Q
          }, a);
        default:
          return null;
      }
    })
  });
};
var Y = "Attributes-module_wrapper__hqOeU",
  q = "Attributes-module_half__uWy7o",
  J = "Attributes-module_gw2Item__3gQwq",
  G = "Attributes-module_gridItem__MDmz9",
  K = "Attributes-module_list__aTKwI";
var Z = function Z(e) {
    return Math.round(100 * e) / 100;
  },
  ee = [{
    name: "Power"
  }, {
    name: "Toughness"
  }, {
    name: "Vitality"
  }, {
    name: "Precision"
  }, {
    name: "Ferocity"
  }, {
    name: "Condition Damage"
  }, {
    name: "Expertise"
  }, {
    name: "Concentration"
  }, {
    name: "Agony Resistance"
  }, {
    name: "Armor"
  }, {
    name: "Health"
  }, {
    name: "Critical Chance",
    text: function text(e) {
      return "".concat(Z(100 * (e || 0)), "%");
    }
  }, {
    name: "Critical Damage",
    text: function text(e) {
      return (s = 100 * (e || 0), Math.round(10 * s) / 10) + "%";
      var s;
    }
  }, {
    name: "Healing Power"
  }, {
    name: "Condition Duration",
    text: function text(e) {
      return "".concat(Z(100 * (e || 0)), "%");
    }
  }, {
    name: "Boon Duration",
    text: function text(e) {
      return "".concat(Z(100 * (e || 0)), "%");
    }
  }, {
    name: "Magic Find",
    text: function text() {
      return "0";
    }
  }],
  se = function se(_ref8) {
    var e = _ref8.profession,
      s = _ref8.data;
    return h.exports.jsxs("div", {
      className: Y,
      children: [h.exports.jsx("div", {
        className: q,
        children: h.exports.jsx("ul", {
          className: K,
          children: ee.slice(0, 9).map(function (_ref9) {
            var e = _ref9.name;
            return h.exports.jsx("li", {
              className: G,
              children: h.exports.jsx(m, {
                name: e,
                text: "".concat(s[e]),
                className: J
              })
            }, e);
          })
        })
      }), h.exports.jsx("div", {
        className: q,
        children: h.exports.jsxs("ul", {
          className: K,
          children: [h.exports.jsx("li", {
            className: G,
            children: h.exports.jsx(u, {
              name: L(e),
              text: "0",
              className: J
            })
          }), ee.slice(9).map(function (_ref10) {
            var e = _ref10.name,
              r = _ref10.text;
            return h.exports.jsx("li", {
              className: G,
              children: h.exports.jsx(m, {
                name: e,
                text: r ? r(s[e]) : "".concat(s[e]),
                className: J
              })
            }, e);
          })]
        })
      })]
    });
  };
var re = "BackAndTrinkets-module_root__BdHVv",
  ie = "BackAndTrinkets-module_gridItem__mA9rg",
  te = "BackAndTrinkets-module_borderLeft__x-YaU",
  ae = "BackAndTrinkets-module_borderBottom__j54n-",
  ne = "BackAndTrinkets-module_upperRowItem__JgPxJ";
var oe = function oe(_ref11) {
    var e = _ref11.infusionIds;
    var r = e.filter(function (e) {
      return !!e;
    }).reduce(function (e, s) {
      return e[s] ? ++e[s] : e[s] = 1, e;
    }, {});
    return h.exports.jsx("div", {
      className: E.infusions,
      children: Object.entries(r).map(function (_ref12, i) {
        var _ref13 = _slicedToArray(_ref12, 2),
          e = _ref13[0],
          r = _ref13[1];
        return h.exports.jsxs(s, {
          children: [0 !== i && h.exports.jsx("br", {}), r, "x ", h.exports.jsx(n, {
            id: Number(e),
            text: V
          })]
        }, "".concat(e, "-").concat(r, "-").concat(i));
      })
    });
  },
  le = function le(_ref14) {
    var e = _ref14.showInfusions,
      s = _ref14.backItemId,
      r = _ref14.backItemInfusion1Id,
      i = _ref14.backItemInfusion2Id,
      a = _ref14.backItemAffix,
      n = _ref14.backItemRarity,
      o = _ref14.accessory1Id,
      l = _ref14.accessory1InfusionId,
      x = _ref14.accessory1Affix,
      d = _ref14.accessory1Rarity,
      p = _ref14.accessory2Id,
      c = _ref14.accessory2InfusionId,
      m = _ref14.accessory2Affix,
      u = _ref14.accessory2Rarity,
      f = _ref14.amuletId,
      j = _ref14.amuletAffix,
      g = _ref14.amuletRarity,
      I = _ref14.ring1Id,
      _ = _ref14.ring1Infusion1Id,
      N = _ref14.ring1Infusion2Id,
      y = _ref14.ring1Infusion3Id,
      w = _ref14.ring1Affix,
      v = _ref14.ring1Rarity,
      b = _ref14.ring2Id,
      A = _ref14.ring2Infusion1Id,
      R = _ref14.ring2Infusion2Id,
      S = _ref14.ring2Infusion3Id,
      T = _ref14.ring2Affix,
      C = _ref14.ring2Rarity;
    var k = E.title;
    return h.exports.jsxs("div", {
      className: re,
      children: [h.exports.jsxs("div", {
        className: t(ie, ae, ne),
        children: [e && h.exports.jsx(oe, {
          infusionIds: [r, i]
        }), h.exports.jsx("span", {
          className: k,
          children: a
        }), h.exports.jsx(F, {
          id: s,
          affix: a,
          rarity: n,
          upgrades: [r, i],
          type: "Back Item"
        })]
      }), h.exports.jsxs("div", {
        className: t(ie, te, ae, ne),
        children: [e && h.exports.jsx(oe, {
          infusionIds: [l]
        }), h.exports.jsx("span", {
          className: k,
          children: x
        }), h.exports.jsx(F, {
          id: o,
          affix: x,
          rarity: d,
          upgrades: [l],
          type: "Accessory"
        })]
      }), h.exports.jsxs("div", {
        className: t(ie, ae, ne),
        children: [e && h.exports.jsx(oe, {
          infusionIds: [c]
        }), h.exports.jsx("span", {
          className: k,
          children: m
        }), h.exports.jsx(F, {
          id: p,
          affix: m,
          rarity: u,
          upgrades: [c],
          type: "Accessory"
        })]
      }), h.exports.jsxs("div", {
        className: ie,
        children: [h.exports.jsx(F, {
          id: f,
          affix: j,
          rarity: g,
          type: "Amulet"
        }), h.exports.jsx("span", {
          className: k,
          children: j
        })]
      }), h.exports.jsxs("div", {
        className: t(ie, te),
        children: [h.exports.jsx(F, {
          id: I,
          affix: w,
          rarity: v,
          upgrades: [_, N, y],
          type: "Ring"
        }), h.exports.jsx("span", {
          className: k,
          children: w
        }), e && h.exports.jsx(oe, {
          infusionIds: [_, N, y]
        })]
      }), h.exports.jsxs("div", {
        className: ie,
        children: [h.exports.jsx(F, {
          id: b,
          affix: T,
          rarity: C,
          upgrades: [A, R, S],
          type: "Ring"
        }), h.exports.jsx("span", {
          className: k,
          children: T
        }), e && h.exports.jsx(oe, {
          infusionIds: [A, R, S]
        })]
      })]
    });
  },
  xe = {
    tiny: 12,
    small: 16,
    medium: 20,
    medium2: 30,
    large: 40,
    large2: 45,
    big: 60,
    gigantic: 70
  };
var de = "NoSelection-module_root__2EXor";
var pe = e.memo(function (_ref15) {
    var e = _ref15.className,
      s = _ref15.size,
      r = _objectWithoutProperties(_ref15, _excluded);
    return h.exports.jsx(a, {
      content: h.exports.jsx(f, {
        children: "Empty Slot"
      }),
      children: h.exports.jsx("span", {
        className: t(de, e),
        style: _objectSpread(_objectSpread({}, s && {
          fontSize: xe[s]
        }), {}, {
          lineHeight: 0,
          fontFamily: "Menomonia"
        }),
        children: h.exports.jsx(j, _objectSpread({
          name: "Empty"
        }, r))
      })
    });
  }),
  ce = "Consumables-module_root__xyU0h",
  me = "Consumables-module_gridItem__6H8hu",
  ue = "Consumables-module_borderLeft__rrtQs";
var fe = function fe(_ref16) {
  var e = _ref16.foodId,
    s = _ref16.utilityId,
    r = _ref16.infusionId,
    i = _ref16.relicId;
  var a = E.gw2Item,
    o = E.title;
  return h.exports.jsxs("div", {
    className: ce,
    children: [h.exports.jsxs("div", {
      className: me,
      children: [e ? h.exports.jsx(n, {
        id: e,
        className: a,
        disableText: !0
      }) : h.exports.jsx(pe, {
        className: a
      }), h.exports.jsxs("span", {
        className: o,
        children: [h.exports.jsx(g, {
          name: "Nourishment",
          disableText: !0
        }), " Food"]
      })]
    }), h.exports.jsxs("div", {
      className: t(me, ue),
      children: [s ? h.exports.jsx(n, {
        id: s,
        className: a,
        disableText: !0
      }) : h.exports.jsx(pe, {
        className: a
      }), h.exports.jsxs("span", {
        className: o,
        children: [h.exports.jsx(g, {
          name: "Enhancement",
          disableText: !0
        }), "Utility"]
      })]
    }), r && h.exports.jsxs("div", {
      className: t(me, ue),
      children: [h.exports.jsx(n, {
        id: r,
        className: a,
        disableText: !0
      }), h.exports.jsx("span", {
        className: o,
        children: "Infusion"
      })]
    }), i && h.exports.jsxs("div", {
      className: t(me, ue),
      children: [h.exports.jsx(n, {
        id: i,
        className: a,
        disableText: !0
      }), h.exports.jsx("span", {
        className: o,
        children: "Relic"
      })]
    })]
  });
};
function je(e) {
  var s = function s(e) {
      return "undefined" != typeof window && window.matchMedia(e).matches;
    },
    _r = r(s(e)),
    _r2 = _slicedToArray(_r, 2),
    t = _r2[0],
    a = _r2[1];
  function n() {
    a(s(e));
  }
  return i(function () {
    var s = window.matchMedia(e);
    return n(), s.addListener ? s.addListener(n) : s.addEventListener("change", n), function () {
      s.removeListener ? s.removeListener(n) : s.removeEventListener("change", n);
    };
  }, [e]), t;
}
var ge = "Legends-module_grid__pA7L2",
  he = "Legends-module_gridItem__TMz86",
  Ie = "Legends-module_skillDesktop__5x-Sx",
  _e = "Legends-module_skillMobile__yR8Ff";
var Ne = function Ne(_ref17) {
  var e = _ref17.legend1Id,
    s = _ref17.legend2Id,
    r = _ref17.className;
  var i = je("(max-width: 600px)") ? _e : Ie;
  return h.exports.jsx(h.exports.Fragment, {
    children: e && s && h.exports.jsxs("div", {
      className: t(r, ge),
      children: [h.exports.jsx("div", {
        className: he,
        children: h.exports.jsx(d, {
          id: e,
          disableText: !0,
          className: i
        })
      }), h.exports.jsx(j, {
        name: "WeaponSwap"
      }), h.exports.jsx("div", {
        className: he,
        children: h.exports.jsx(d, {
          id: s,
          disableText: !0,
          className: i
        })
      })]
    })
  });
};
var ye = "Skills-module_grid__r4-eL",
  we = "Skills-module_gridItem__d6v-Q",
  ve = "Skills-module_gridItemMiddle__By3hb",
  be = "Skills-module_borders__EDgxs";
var Ae = function Ae(_ref18) {
  var e = _ref18.healId,
    s = _ref18.utility1Id,
    r = _ref18.utility2Id,
    i = _ref18.utility3Id,
    a = _ref18.eliteId,
    n = _ref18.className;
  var o = E.gw2Item,
    l = E.title,
    x = je("(max-width: 600px)") ? "large" : "big";
  return h.exports.jsxs("div", {
    className: t(n, ye),
    children: [h.exports.jsxs("div", {
      className: we,
      children: [e ? h.exports.jsx(d, {
        id: e,
        className: o,
        disableText: !0
      }) : h.exports.jsx(pe, {
        size: x
      }), h.exports.jsx("span", {
        className: l,
        children: "Heal"
      })]
    }), h.exports.jsxs("div", {
      className: t(we, ve, be),
      children: [h.exports.jsxs("div", {
        children: [s ? h.exports.jsx(d, {
          id: s,
          className: o,
          disableText: !0
        }) : h.exports.jsx(pe, {
          size: x
        }), r ? h.exports.jsx(d, {
          id: r,
          className: o,
          disableText: !0
        }) : h.exports.jsx(pe, {
          size: x
        }), i ? h.exports.jsx(d, {
          id: i,
          className: o,
          disableText: !0
        }) : h.exports.jsx(pe, {
          size: x
        })]
      }), h.exports.jsx("span", {
        className: l,
        children: "Utilities"
      })]
    }), h.exports.jsxs("div", {
      className: t(we),
      children: [h.exports.jsx("div", {
        children: a ? h.exports.jsx(d, {
          id: a,
          className: o,
          disableText: !0
        }) : h.exports.jsx(pe, {
          size: x
        })
      }), h.exports.jsx("span", {
        className: l,
        children: "Elite"
      })]
    })]
  });
};
var Re = "TextDivider-module_root__AV5H1",
  Se = "TextDivider-module_divider__PDpiG",
  Te = "TextDivider-module_content__zeOs1";
var Ce = function Ce(_ref19) {
  var e = _ref19.className,
    s = _ref19.text,
    r = _ref19.children;
  return h.exports.jsxs("div", {
    className: t(Re, e),
    children: [h.exports.jsx("div", {
      className: Se
    }), h.exports.jsx("div", {
      className: Te,
      children: s || r
    }), h.exports.jsx("div", {
      className: Se
    })]
  });
};
function ke(e) {
  return e.filter(function (e) {
    return "number" == typeof e;
  });
}
function Me(e) {
  return L(e.replace("Superior Sigil of ", "").replace("Überlegenes Sigill der ", "").replace("Überlegenes Sigill des ", "").replace("Rune d'érudit ", ""));
}
var Oe = function Oe(_ref20) {
  var _ref20$showInfusions = _ref20.showInfusions,
    e = _ref20$showInfusions === void 0 ? !0 : _ref20$showInfusions,
    s = _ref20.weapon1MainId,
    r = _ref20.weapon1MainSigil1Id,
    i = _ref20.weapon1MainSigil2Id,
    t = _ref20.weapon1MainType,
    a = _ref20.weapon1MainAffix,
    o = _ref20.weapon1MainSigil1,
    l = _ref20.weapon1MainSigil2,
    x = _ref20.weapon1MainInfusion1Id,
    d = _ref20.weapon1MainInfusion2Id,
    p = _ref20.weapon1MainRarity,
    c = _ref20.weapon1OffId,
    m = _ref20.weapon1OffSigilId,
    u = _ref20.weapon1OffType,
    f = _ref20.weapon1OffAffix,
    g = _ref20.weapon1OffSigil,
    I = _ref20.weapon1OffInfusionId,
    _ = _ref20.weapon1OffRarity,
    N = _ref20.weapon2MainId,
    y = _ref20.weapon2MainSigil1Id,
    w = _ref20.weapon2MainSigil2Id,
    v = _ref20.weapon2MainType,
    b = _ref20.weapon2MainAffix,
    A = _ref20.weapon2MainSigil1,
    R = _ref20.weapon2MainSigil2,
    S = _ref20.weapon2MainInfusion1Id,
    T = _ref20.weapon2MainInfusion2Id,
    C = _ref20.weapon2MainRarity,
    k = _ref20.weapon2OffId,
    M = _ref20.weapon2OffSigilId,
    O = _ref20.weapon2OffType,
    E = _ref20.weapon2OffAffix,
    L = _ref20.weapon2OffSigil,
    P = _ref20.weapon2OffInfusionId,
    U = _ref20.weapon2OffRarity;
  var V = je("(max-width: 600px)"),
    W = function W(_ref21) {
      var s = _ref21.affix,
        r = _ref21.infusion1Id,
        i = _ref21.infusion2Id,
        t = _ref21.sigil1Id,
        a = _ref21.sigil1Name,
        o = _ref21.sigil2Id,
        l = _ref21.sigil2Name;
      return h.exports.jsx("div", {
        className: H,
        children: s ? h.exports.jsxs(h.exports.Fragment, {
          children: [h.exports.jsx("span", {
            className: D,
            children: s
          }), h.exports.jsxs("div", {
            className: $,
            children: [t ? h.exports.jsx(n, {
              id: t,
              text: Me
            }) : a, (o || l) && h.exports.jsx("br", {}), o ? h.exports.jsx(n, {
              id: o,
              text: Me
            }) : l, e && h.exports.jsx(h.exports.Fragment, {
              children: h.exports.jsx(oe, {
                infusionIds: [r, i]
              })
            })]
          })]
        }) : h.exports.jsx("span", {
          className: D,
          children: "Empty"
        })
      });
    };
  return h.exports.jsxs(h.exports.Fragment, {
    children: [h.exports.jsxs("ul", {
      className: z,
      children: [h.exports.jsx("li", {
        className: B,
        children: s || t ? h.exports.jsxs(h.exports.Fragment, {
          children: [h.exports.jsx(F, {
            id: s,
            affix: a,
            rarity: p,
            type: t,
            upgrades: ke([r, i, x, d])
          }), h.exports.jsx(W, {
            affix: a,
            infusion1Id: x,
            infusion2Id: d,
            sigil1Id: r,
            sigil1Name: o,
            sigil2Id: i,
            sigil2Name: l
          })]
        }) : h.exports.jsxs(h.exports.Fragment, {
          children: [h.exports.jsx(pe, {
            size: V ? "large2" : "big"
          }), h.exports.jsx(W, {})]
        })
      }), (c || u) && h.exports.jsxs("li", {
        className: B,
        children: [h.exports.jsx(F, {
          id: c,
          affix: f,
          rarity: _,
          type: u,
          upgrades: ke([m, I])
        }), h.exports.jsx(W, {
          affix: f,
          infusion1Id: I,
          sigil1Id: m,
          sigil1Name: g
        })]
      }), !c && !u && !i && h.exports.jsxs("li", {
        className: B,
        children: [h.exports.jsx(pe, {
          size: V ? "large2" : "big"
        }), h.exports.jsx(W, {})]
      })]
    }), (N || k || v || O) && h.exports.jsxs(h.exports.Fragment, {
      children: [h.exports.jsx(Ce, {
        children: h.exports.jsx(j, {
          name: "WeaponSwap"
        })
      }), h.exports.jsxs("ul", {
        className: z,
        children: [N || v ? h.exports.jsxs("li", {
          className: B,
          children: [h.exports.jsx(F, {
            id: N,
            affix: b,
            rarity: C,
            type: v,
            upgrades: ke([y, w, S, T])
          }), h.exports.jsx(W, {
            affix: b,
            infusion1Id: S,
            infusion2Id: T,
            sigil1Id: y,
            sigil1Name: A,
            sigil2Id: w,
            sigil2Name: R
          })]
        }) : h.exports.jsxs("li", {
          className: B,
          children: [h.exports.jsx(pe, {
            size: V ? "large2" : "big"
          }), h.exports.jsx(W, {})]
        }), (k || O) && h.exports.jsxs("li", {
          className: B,
          children: [h.exports.jsx(F, {
            id: k,
            affix: E,
            rarity: U,
            type: O,
            upgrades: ke([M, P])
          }), h.exports.jsx(W, {
            affix: E,
            infusion1Id: P,
            sigil1Id: M,
            sigil1Name: L
          })]
        }), !k && !O && !w && h.exports.jsxs("li", {
          className: B,
          children: [h.exports.jsx(pe, {
            size: V ? "large2" : "big"
          }), h.exports.jsx(W, {})]
        })]
      })]
    })]
  });
};
var Ee = "Character-module_top__fL5FU",
  Fe = "Character-module_section__4hfm6",
  Le = "Character-module_assumedBuffs__qaB43",
  ze = "Character-module_wrapper__CWfsi",
  Be = "Character-module_side__9ul69",
  He = "Character-module_middle__9mfV2",
  De = "Character-module_skillsLegends__iQo2V";
var $e = function $e(_ref22) {
  var s = _ref22.attributes,
    r = _ref22.assumedBuffs,
    i = _ref22.armor,
    a = _ref22.weapon,
    n = _ref22.skills,
    o = _ref22.legends,
    l = _ref22.backAndTrinket,
    x = _ref22.consumables,
    d = _ref22.imageElement,
    _ref22$switchElement = _ref22.switchElement,
    p = _ref22$switchElement === void 0 ? O : _ref22$switchElement,
    _ref22$disableSwitch = _ref22.disableSwitch,
    c = _ref22$disableSwitch === void 0 ? !1 : _ref22$disableSwitch;
  var _e$useState = e.useState(!1),
    _e$useState2 = _slicedToArray(_e$useState, 2),
    m = _e$useState2[0],
    u = _e$useState2[1],
    f = function f(_ref23) {
      var e = _ref23.children,
        s = _ref23.style,
        r = _ref23.className;
      return h.exports.jsx("div", {
        className: t(r, Fe),
        style: s,
        children: e
      });
    };
  return h.exports.jsxs(h.exports.Fragment, {
    children: [h.exports.jsxs("div", {
      className: Ee,
      children: [h.exports.jsx("div", {
        children: !c && h.exports.jsx(p, {
          onChange: function onChange(e) {
            return u(e.target.checked);
          },
          label: "Show Infusions"
        })
      }), r && h.exports.jsxs("div", {
        className: Le,
        children: [h.exports.jsx(S, {
          text: "Assumed buffs for this build"
        }), h.exports.jsx(X, _objectSpread({}, r))]
      })]
    }), h.exports.jsxs("div", {
      className: ze,
      children: [h.exports.jsxs("div", {
        className: Be,
        children: [h.exports.jsx(f, {
          children: h.exports.jsx(W, _objectSpread(_objectSpread({}, i), {}, {
            showInfusions: m
          }))
        }), h.exports.jsx(f, {
          children: h.exports.jsx(Oe, _objectSpread(_objectSpread({}, a), {}, {
            showInfusions: m
          }))
        })]
      }), h.exports.jsxs("div", {
        className: He,
        children: [d, (n || o) && h.exports.jsxs(f, {
          className: De,
          children: [n && h.exports.jsx(Ae, _objectSpread({}, n)), o && h.exports.jsx(Ne, _objectSpread({}, o))]
        })]
      }), h.exports.jsxs("div", {
        className: Be,
        children: [h.exports.jsx(f, {
          children: h.exports.jsx(se, _objectSpread({}, s))
        }), h.exports.jsx(f, {
          children: h.exports.jsx(le, _objectSpread(_objectSpread({}, l), {}, {
            showInfusions: m
          }))
        }), h.exports.jsx(f, {
          children: h.exports.jsx(fe, _objectSpread({}, x))
        })]
      })]
    })]
  });
};
export { W as Armor, X as AssumedBuffs, se as Attributes, le as BackAndTrinkets, $e as Character, fe as Consumables, S as HelperIcon, Ne as Legends, pe as NoSelection, Ae as Skills, Ce as TextDivider, Oe as Weapons, L as firstUppercase, xe as iconSizes, je as useMediaQuery };